module.exports = "<a l10n=\"\" ng-click=$ctrl.navigateToRulesPage()>Rules</a>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/atc/atc-flights-view/flight-rules-link/flight-rules-link.html
// module id = 3640
// module chunks = 0